import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Alert
} from '@mui/material';
import { useAuth } from '../../hooks/auth/useAuth';
import AuthDialog from './AuthDialog';
//import LoginDialog from './Auth';
import { LoginPromptType } from '../../utils/auth/loginPromptManager';
//import { authService } from '../../utils/auth/authService';
interface ReloginDialogProps {
    open: boolean;
    onClose: () => void;
}

const ReloginDialog: React.FC<ReloginDialogProps> = ({ open, onClose }) => {
    const { lostUserInfo, clearReloginFlag, createAnonymousAccount, saveUserInfoToCookie } = useAuth();
    //const [showLoginDialog, setShowLoginDialog] = useState(false);
    const [showAuthDialog, setShowAuthDialog] = useState(false);

    // Handlers using centralized auth state
    const handleRelogin = () => {
        setShowAuthDialog(false);
        //setShowLoginDialog(true);
    };

    const handleCreateNewAccount = () => {
        //setShowLoginDialog(false);
        setShowAuthDialog(true);
    };

    const handleContinueAsGuest = async () => {
        try {
            // Create new anonymous account on server and force save
            const anonUser = await createAnonymousAccount();
            saveUserInfoToCookie(anonUser, true);

            clearReloginFlag();
            onClose();
        } catch (error) {
            console.error("Failed to create anonymous account:", error);
            // Still clear flags and close even if there's an error
            clearReloginFlag();
            onClose();
        }
    };

    //const handleLoginDialogClose = () => {
    //    setShowLoginDialog(false);
    //};

    //const handleLoginSuccess = () => {
    //    setShowLoginDialog(false);
    //    clearReloginFlag();
    //    onClose();
    //};

    const handleAuthDialogClose = () => {
        setShowAuthDialog(false);
    };

    const handleAuthSuccess = () => {
        setShowAuthDialog(false);
        clearReloginFlag();
        onClose();
    };

    return (
        <>
            <Dialog
                open={open}
                onClose={() => { }} // Prevent closing by clicking outside
                aria-labelledby="relogin-dialog-title"
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle id="relogin-dialog-title">
                    Account Information Required
                </DialogTitle>
                <DialogContent>
                    <Alert severity="warning" sx={{ mb: 2 }}>
                        Your account information could not be retrieved.
                    </Alert>
                    <DialogContentText>
                        We are unable to find your current account details. This may occur if:
                        <ul>
                            <li>Your account was deleted or deactivated</li>
                            <li>Our database has been reset</li>
                            <li>Your device holds outdated session data</li>
                        </ul>
                        {lostUserInfo ? (
                            <div>
                                <p>Previously, we detected the following details:</p>
                                <p>
                                    <strong>Username:</strong> {lostUserInfo.userName}
                                </p>
                                {lostUserInfo.email && (
                                    <p>
                                        <strong>Email:</strong> {lostUserInfo.email}
                                    </p>
                                )}
                            </div>
                        ) : (
                            <p>No previous account information was found.</p>
                        )}
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ flexDirection: 'column', alignItems: 'flex-end', p: 3 }}>
                    <Button
                        onClick={handleRelogin}
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{ mb: 1 }}
                    >
                        Sign In with Existing Account
                    </Button>
                    <Button
                        onClick={handleCreateNewAccount}
                        variant="outlined"
                        color="primary"
                        fullWidth
                        sx={{ mb: 1 }}
                    >
                        Create New Account
                    </Button>
                    <Button onClick={handleContinueAsGuest} color="primary" fullWidth>
                        Continue as Guest
                    </Button>
                </DialogActions>
            </Dialog>

            <AuthDialog
                open={showAuthDialog}
                onClose={handleAuthDialogClose}
                onSuccess={handleAuthSuccess}
                defaultPromptType={LoginPromptType.CREATE_ACCOUNT}
            />
        </>
    );
};

export default ReloginDialog;
